const defaultState = {
  chartReviewNotes: {},
}

export default function chartNotesReducer(state = defaultState, action) {
  switch (action.type) {
    case "SET_CHART_FROM_SERVER_TO_FORM":
      const chartReviewNotes = formatChartNotesFromServer(action.payload)
      return { ...state, chartReviewNotes }
    case "ADD_CHART_REVIEW_NOTE":
      return { 
        ...state, 
        chartReviewNotes: addChartReviewNoteToState(state.chartReviewNotes, action.payload),
      }
    case "EDIT_CHART_REVIEW_NOTE":
      return { 
        ...state, 
        chartReviewNotes: editChartReviewNoteInState(state.chartReviewNotes, action.payload),
      }
    default:
      return state
  }
}


const formatChartNotesFromServer = (chart) => {
  if (!chart.chart_review_notes || !Array.isArray(chart.chart_review_notes)) {
    return {}
  }

  let notes = {}
  chart.chart_review_notes.forEach(note => {
    if (notes[note.section]) {
      notes[note.section].push(note)
    } else {
      notes[note.section] = [note]
    }
  })

  if (chart.antibiotics_use && chart.antibiotics_use.cefiderocol_adverse_events) {
    notes = formatAdverseEventNotesForServer(notes, chart.antibiotics_use.cefiderocol_adverse_events)
  }

  return notes
}


const formatAdverseEventNotesForServer = (notes, adverseEvents) => {
  notes['ADR'] = {}
  adverseEvents.forEach(adverseEvent => {
    if (Array.isArray(adverseEvent.adverse_event_review_notes) && adverseEvent.adverse_event_review_notes.length) {
      let adverseEventName = adverseEvent.name
      let counter = 2
      while (Object.keys(notes['ADR']).includes(adverseEventName)) {
        adverseEventName = `${adverseEvent.name} (${counter})`
        counter += 1
      }

      notes['ADR'][adverseEventName] = {
        notes: adverseEvent.adverse_event_review_notes,
        url: adverseEvent.url
      }
    }
  })

  return notes
}


export const addChartReviewNote = (note) => {
  return { type: "ADD_CHART_REVIEW_NOTE", payload: note }
}

const addChartReviewNoteToState = (allNotes, newNote) => {
  if (!newNote || !newNote.section) {
    return allNotes
  }

  const updatedNotes = {...allNotes}

  if (newNote.section === 'ADR') {
    if (updatedNotes['ADR'][newNote.adverseEventName] && Array.isArray(updatedNotes['ADR'][newNote.adverseEventName].notes)) {
      updatedNotes['ADR'][newNote.adverseEventName].notes.push(newNote)
    } else {
      updatedNotes['ADR'][newNote.adverseEventName] = {
        notes: [newNote],
        url: newNote.cefiderocol_adverse_event
      }
    }
  } else if (updatedNotes[newNote.section] && Array.isArray(updatedNotes[newNote.section])) {
    updatedNotes[newNote.section].push(newNote)
  } else {
    updatedNotes[newNote.section] = [newNote]
  }

  return updatedNotes
}


export const editChartReviewNote = (note) => {
  return { type: "EDIT_CHART_REVIEW_NOTE", payload: note }
}

const editChartReviewNoteInState = (allNotes, modifiedNote) => {
  if (!modifiedNote || !modifiedNote.section) {
    return allNotes
  }

  const updatedNotes = {...allNotes}

  if (modifiedNote.section === 'ADR') {
    if (updatedNotes['ADR'][modifiedNote.adverseEventName] && Array.isArray(updatedNotes['ADR'][modifiedNote.adverseEventName].notes)) {
      const updatedADRNotes = updateArrayElement(updatedNotes['ADR'][modifiedNote.adverseEventName].notes, modifiedNote)
      updatedNotes['ADR'][modifiedNote.adverseEventName].notes = updatedADRNotes
    } else {
      updatedNotes['ADR'][modifiedNote.adverseEventName] = {
        notes: [modifiedNote],
        url: modifiedNote.cefiderocol_adverse_event
      }
    }
  } else if (updatedNotes[modifiedNote.section] && Array.isArray(updatedNotes[modifiedNote.section])) {
    let sectionNotes = updatedNotes[modifiedNote.section]
    const updatedSectionNotes = updateArrayElement(sectionNotes, modifiedNote)
    
    updatedNotes[modifiedNote.section] = updatedSectionNotes
  } else {
    updatedNotes[modifiedNote.section] = [modifiedNote]
  }

  return updatedNotes
}


const updateArrayElement = (array, modifiedElement) => {
  const index = array.findIndex(element => element.url === modifiedElement.url)
  return [
    ...array.slice(0, index),
    modifiedElement,
    ...array.slice(index + 1)
  ]
}